/**
 * Build salesApiLeadSearch `query=` value for a single Sales Navigator lead list.
 * Mirrors the LEAD_LIST filter shape from LinkedIn SN People Search (see curl1).
 */
export function buildSalesNavListSearchQuery(listId: string, listName = ''): string {
  const id = String(listId || '').trim();
  // Rest.li filter text — strip chars that break the unquoted token.
  const text = String(listName || 'list')
    .trim()
    .replace(/[,:()]/g, ' ')
    .replace(/\s+/g, ' ')
    .slice(0, 80) || 'list';
  return `(spellCorrectionEnabled:true,filters:List((type:LEAD_LIST,values:List((id:${id},text:${text},selectionType:INCLUDED,icon:list)))))`;
}

export type TSalesNavLeadPreview = {
  publicIdentifier?: string;
  /** Sales Nav member id (ACw…) when known separately from vanity. */
  salesMemberId?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  title?: string;
  company?: string;
  geoRegion?: string;
  profilePicture?: string | null;
  salesEntityUrn?: string;
  degree?: number | string | null;
  summary?: string | null;
};
